<template>
    <div class="er-type-step">
        <div class="er-type-step-title">{{$store.getters.t('expenditure_request_create_step_choose_type')}}</div>
        <div class="er-type-step-options">
            <div class="er-type-step-option er-card"
                 :class="{selected: expenditureRequest.expenditure_id === option.expenditure_id}"
                 v-for="option in options"
                 @click="updateExpenditureRequest({key: 'expenditure_id', data: option.expenditure_id})"
            >
                <div class="er-type-step-option-title">{{$store.getters.t(option.titleKey)}} <img :src="option.icon" alt=""></div>
                <div class="er-type-step-option-desc">{{$store.getters.t(option.descriptionKey)}}</div>
            </div>
        </div>
    </div>

</template>

<script>
import {mapGetters, mapMutations} from "vuex";

export default {
    name: "ExpenditureRequestTypeStep.vue",
    data(){
        return {
            options: [
                {
                    titleKey: 'expenditure_request_type_medical_title',
                    descriptionKey: 'expenditure_request_type_medical_desc',
                    type: 'allotment_request',
                    expenditure_id: 4,
                    icon: '/assets/images/svg/medical.svg'
                },
                {
                    titleKey: 'expenditure_request_type_goods_title',
                    descriptionKey: 'expenditure_request_type_goods_desc',
                    type: 'allotment_request',
                    expenditure_id: 3,
                    icon: '/assets/images/svg/shop.svg'

                },
                {
                    titleKey: 'expenditure_request_type_homestay_title',
                    descriptionKey: 'expenditure_request_type_homestay_desc',
                    type: 'allotment_request',
                    expenditure_id: 8,
                    icon: '/assets/images/svg/home.svg'
                },
/*                {
                    titleKey: 'expenditure_request_type_advertising_title',
                    descriptionKey: 'expenditure_request_type_advertising_desc',
                    type: 'allotment_request',
                    expenditure_id: 7,
                    icon: '/assets/images/svg/dog.svg'
                },*/
                {
                    titleKey: 'expenditure_request_type_other_title',
                    descriptionKey: 'expenditure_request_type_other_desc',
                    type: 'allotment_request',
                    expenditure_id: 5,
                    icon: '/assets/images/svg/bowl.svg'
                },
            ]
        }
    },
    computed: {
        ...mapGetters({
            expenditureRequest: 'getterExpenditureRequest'
        })
    },
    methods: {
        ...mapMutations({updateExpenditureRequest: 'setterExpenditureRequestParam'})
    }
}
</script>

<style lang="scss" scoped>
.er-type-step {
    &-title {
        font-weight: 700;
        font-size: 24px;
        line-height: 34px;
        text-align: center;
        margin-bottom: 50px;
    }

    &-option {
        margin-bottom: 30px;
        cursor: pointer;



        &-title {
            font-weight: 700;
            font-size: 24px;
            line-height: 34px;

            img {
                margin-left: 40px;
            }
        }
        &-desc {
            margin-top: 30px;
            font-size: 14px;
            line-height: 20px;
            max-width: 620px;
        }
    }
}
</style>
